var lib_core = require("lib-core");

var AbstractToolController = require("./../../../extensions/abstractToolController.js");
var TextToolStateMachine = require("./textToolStateMachine.js");

var TextToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        font: "Verdana",
        fontSize: 10,
        strokeWidth: 2
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(TextToolController, AbstractToolController);
TextToolController.inject = AbstractToolController.inject;
TextToolController.StateMachineClass = TextToolStateMachine;

module.exports = TextToolController;

TextToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Text',
        title: 'Text',
        style: {
            icon: 'icon-text.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
